uniform sampler2D tDiffuse;
uniform float amount;
uniform vec2 resolution;

varying vec2 vUv;

void main() {
    vec2 pixel = 1.0 / resolution;
    vec4 colorCenter = texture2D(tDiffuse, vUv);
    vec4 colorN = texture2D(tDiffuse, vUv + vec2(0.0, -1.0) * pixel);
    vec4 colorE = texture2D(tDiffuse, vUv + vec2(1.0, 0.0) * pixel);
    vec4 colorS = texture2D(tDiffuse, vUv + vec2(0.0, 1.0) * pixel);
    vec4 colorW = texture2D(tDiffuse, vUv + vec2(-1.0, 0.0) * pixel);

    gl_FragColor = mix(colorCenter, colorCenter * 5.0 - (colorN + colorE + colorS + colorW), amount);
}
